<h1 class="auth-status-heading">
  {{'auth.invitation.deny_title' | translate}}</h1>
<app-spinner></app-spinner>
